import { useQuery } from '@apollo/client';
import { fetchEmailDetails, EmailPreview } from '@css-xp/email';
import * as React from 'react';
import { Email, generatedTypesNew } from '@css-xp/graphtypes';
import { ErrorComponents } from '../..';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import { withApollo } from '../../graphql-provider';

interface Props {
  emailId: string;
}

export const EmailPreviewPane = React.memo(({ emailId }: Props) => {
  const { data, loading, error } = useQuery<
    generatedTypesNew.FetchEmailDetailsQuery,
    generatedTypesNew.FetchEmailDetailsQueryVariables
  >(fetchEmailDetails, {
    variables: {
      email: emailId,
    },
    fetchPolicy: 'no-cache',
  });

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorComponents.GenericErrorPage error={error} />;
  }

  const emailDetails = data?.fetchEmailDetails as Email;
  if (!emailDetails) {
    return (
      <ErrorComponents.ErrorPanel
        error={new ErrorComponents.NotFoundError(`Unable to find email with ID: ${emailId}`)}
      />
    );
  }

  return <EmailPreview emailDetails={emailDetails} />;
});

export default withApollo(EmailPreviewPane);
